import { useParameters } from './useParameters';

const validParameters = ['true', '1', ''];

export const useShowRestricted = () => {
  const { parameters } = useParameters();
  let showRestricted = false;

  if (parameters.showRestricted !== undefined) {
    showRestricted = validParameters.includes(parameters.showRestricted.toLowerCase());
  }

  const filter = showRestricted ? `?showRestricted=${parameters.showRestricted}` : '';

  return { showRestricted, filter };
};
